import {defineAsyncComponent} from 'vue'

export const AppComponents = {
    'pi-contact': defineAsyncComponent(() => import('./ContactView.vue')),
    'pi-we-call-you': defineAsyncComponent(() => import('./WeCallYouView.vue')),
    'pi-offer': defineAsyncComponent(() => import('./OfferView.vue')),
}
